import { render, staticRenderFns } from "./timeDomains_Chats.vue?vue&type=template&id=20ddc0f5&scoped=true"
import script from "./timeDomains_Chats.vue?vue&type=script&lang=js"
export * from "./timeDomains_Chats.vue?vue&type=script&lang=js"
import style0 from "./timeDomains_Chats.vue?vue&type=style&index=0&id=20ddc0f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ddc0f5",
  null
  
)

export default component.exports